import { Languages } from '@/Languages'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'


export function LanguageSelect({language}: any) {
    return (
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-slate-500">
            {Languages.find(e => e.languageCode === language)?.languageFlag} 
          </MenuButton>
        </div>
        <MenuItems          
          className="absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-slate-900 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="py-1">
            {Languages.map((e) => {
               return <MenuItem key={e.languageCode}>
               <a title={e.languageCode} href={e.languagePath} className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none">                
                {e.languageFlag}
               </a>
             </MenuItem> 
            })}            
          </div>
        </MenuItems>
      </Menu>
    )
  }